import api from "PFCore/api";
import { Id } from "PFTypes/id";

export type DeleteSkillsFrameworkResponse = { id: Id };
type DeleteSkillsFrameworkPayload = { id: Id; force?: boolean };

export const deleteSkillsFramework = ({
  id,
  force = false
}: DeleteSkillsFrameworkPayload): Promise<DeleteSkillsFrameworkResponse> =>
  api({
    url: `admin/skills_framework/templates/${id}`,
    method: "DELETE",
    data: { force }
  });
